import {Injectable} from '@angular/core';

import {AuthenticationService} from './index';

import {ControlItem} from '../_models/index';
import {LoginHelper} from '../helpers';
import {BehaviorSubject} from "rxjs";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class ControlItemsService {

  public controlItems: ControlItem[];

  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config:IndexConfigService) {
  }

  getAll(tenantName: string = null, reset = false) {

    if (this.controlItems)
    {
      return new BehaviorSubject(this.controlItems);
    }
    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http
      .get<any>(this.config.api + '/api/controlItems/all');
  }

  @Load()
  getComplianceAreaControlItems(complianceAreaId: number, tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http
      .get<any>(this.config.api + '/api/controlItems/compliancearea/' + complianceAreaId + '')
      ;
  }

  getById(id: number, tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http.get<any>(this.config.api + '/api/controlItems/controlItem/' + id + '')
      ;
  }

  getComplianceAreaPairings(tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http.get<any>(this.config.api + '/api/controlItems/pairings/')
      ;
  }

  @Load()
  create(controlItem: ControlItem, tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }
    this.controlItems = null;
    return this.http.post<any>(this.config.api + '/api/controlItems/create', controlItem)
      ;
  }

  @Load()
  update(controlItem: ControlItem, tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    this.controlItems = null;
    return this.http.put(this.config.api + '/api/controlItems/update/' + controlItem.controlItemId + '', controlItem)
      ;
  }

  @Load()
  deleteArea(id: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }
    this.controlItems = null;
    return this.http.delete<any>(this.config.api + '/api/complianceAreas/' + id + '')
      ;
  }

  @Load()
  delete(id: number, tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    this.controlItems = null;
    return this.http.delete(this.config.api + '/api/controlItems/delete/' + id + '')
      ;
  }
  @Load()
  deletePairing(id: number, tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http.delete(this.config.api + '/api/controlItems/pairings/' + id + '')
      ;
  }

  @Load()
  deleteRange(ids: number[], tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    this.controlItems = null;
    return this.http.put<any>(this.config.api + '/api/controlItems/delete', {ids: ids})
      ;
  }

  @Load()
  getPrediction(projectId: number, tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    this.controlItems = null;
    return this.http.get<any>(this.config.api + `/api/controlItems/prediction/${projectId}`)
      ;
  }

  saveOrder(orderMap: any){
      const tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }

    this.controlItems = null;
    return this.http.post<any>(this.config.api + `/api/controlItems/order`, orderMap);
  }
}
